// extracted by mini-css-extract-plugin
module.exports = {"block":"ProfileReferralBlock_block__Zin1H"};